import { useEffect, lazy } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { ReactQueryDevtools } from 'react-query/devtools';

const PageSelect = lazy(async () => await import('@/pages/pageSelect/page'));
const Editor = lazy(async () => await import('@/pages/editor/page'));
const AddModule = lazy(async () => await import('@/pages/addModule/page'));
const PlayerPage = lazy(async () => await import('@/pages/player/page'));
const Error404 = lazy(async () => await import('@/pages/error404/page'));
const MathTest = lazy(async () => await import('@/pages/mathTest/page'));
const ExamPaper = lazy(async () => await import('@/pages/examPaper/page'));

function MainRouter() {
  useEffect(() => {
    console.info(
      `%c
      █████████████████████████████████████████████████████████████╗
      ██                                                         ██║
      ██  %c ██████╗ ███╗   ██╗███████╗██╗      ██████╗ ██╗   ██╗ %c ██║
      ██  %c██╔═══██╗████╗  ██║██╔════╝██║     ██╔═══██╗██║   ██║ %c ██║
      ██  %c██║   ██║██╔██╗ ██║█████╗  ██║     ██║   ██║██║   ██║ %c ██║
      ██  %c██║   ██║██║╚██╗██║██╔══╝  ██║     ██║   ██║██║   ██║ %c ██║
      ██  %c╚██████╔╝██║ ╚████║██║     ███████╗╚██████╔╝╚██████╔╝ %c ██║
      ██  %c ╚═════╝ ╚═╝  ╚═══╝╚═╝     ╚══════╝ ╚═════╝  ╚═════╝  %c ██║
      ██                                                         ██║
      █████████████████████████████████████████████████████████████║
       ╚═══════════════════════════════════════════════════════════╝
  `,
      'color:#ff006c',
      'color:#00d3ff',
      'color:#ff006c',
      'color:#00d3ff',
      'color:#ff006c',
      'color:#00d3ff',
      'color:#ff006c',
      'color:#00d3ff',
      'color:#ff006c',
      'color:#00d3ff',
      'color:#ff006c',
      'color:#00d3ff',
      'color:#ff006c'
    );
  }, []);

  return (
    <>
      <Routes>
        <Route path='/' element={<PageSelect />}></Route>
        <Route path='/editor' element={<Editor />}></Route>
        <Route path='/editor/addModule' element={<AddModule />}></Route>
        <Route path='/player' element={<PlayerPage />}></Route>
        <Route path='/mathTest' element={<MathTest />}></Route>
        {import.meta.env.VITE_APP_MODE === 'dev' && <Route path='/mathTest' element={<MathTest />}></Route>}
        <Route path='/examPaper' element={<ExamPaper />}></Route>
        <Route path='*' element={<Error404 />}></Route>
      </Routes>
      <ReactQueryDevtools initialIsOpen={false} position='bottom-right' />
    </>
  );
}

export default MainRouter;
